"use strict";

import angular from "angular";
import LegalController from "./legal.controller";

export default angular
  .module("dalApp.legal", [])
  .controller("LegalController", LegalController).name;



// WEBPACK FOOTER //
// ./client/app/account/legal/index.js